// The pure half of a map-pin write: given the array stored on the incident,
// produce the array to store back. Both the web app and the mobile app do this
// same replace-by-id, and getting it wrong is how a pin ends up duplicated or
// undeletable, so it lives on its own with a check next to it.
//
// CommonJS on purpose so `node applyMarkerWrite.check.js` can run it without a
// build step.
//
// markers  - the array as currently stored
// markerId - the pin's `id`; the ONLY identity. Never match on the whole object:
//            two people editing the same pin make the objects differ, and a
//            deep-equality match then silently misses.
// update   - fields to merge onto the pin, or null to delete it
function applyMarkerWrite(markers, markerId, update) {
  const list = Array.isArray(markers) ? markers : []
  const existing = list.find((m) => m && m.id === markerId)
  const kept = list.filter((m) => !m || m.id !== markerId)
  if (!update) return kept
  return [...kept, { ...existing, ...update, id: markerId }]
}

module.exports = { applyMarkerWrite }
